// translations/pages/events/fi.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageFI = {
  title: 'Tapahtumat',
  upcoming: 'Tulevat tapahtumat',
  past: 'Menneet tapahtumat',
  all: 'Kaikki tapahtumat',
  items: {
    wikki26: {
      title: 'WiKKI26 – Wildaun tekoälykonferenssi',
      description: 'pAIoneer Labs oli näytteilleasettajana Technische Hochschule Wildaussa. Osastolla aiheena oli, miten paikallinen tekoälyinfrastruktuuri rakennetaan yrityksissä ja organisaatioissa: datasuvereniteetti, sisäänrakennettu tietosuoja ja lainmukainen tekoäly ilman tarpeetonta riippuvuutta ulkoisista pilviratkaisuista.'
    }
  }
};
